<template>
  <div class="handlePic">
    <div class="wrp">
      <div class="ant-upload ant-upload-drag main-col flex-center">
        <a-spin :spinning="changeClsSpin" tips="换装中...">
          <div
            class="img-wrap"
            v-if="colors[colorsIdx]"
            :style="{
              backgroundImage: `linear-gradient(to bottom,#${colors[colorsIdx].s_color},#${colors[colorsIdx].e_color})`,
            }"
          >
            <div
              class="sure-wrap"
              :style="{
                width: `${ruleItemInfo.width_px}px`,
                height: `${ruleItemInfo.height_px}px`,
              }"
            >
              <div class="horn">
                <div class="lt"></div>
                <div class="rt"></div>
                <div class="rb"></div>
                <div class="lb"></div>
              </div>
              <div class="wpx">
                {{ actualRuleInfo.width_px || ruleItemInfo.width_px }}px
              </div>
              <div class="hpx">
                {{ actualRuleInfo.height_px || ruleItemInfo.height_px }}px
              </div>
              <div class="wmm">{{ ruleItemInfo.width_mm }}mm</div>
              <div class="hmm">{{ ruleItemInfo.height_mm }}mm</div>
              <img
                v-show="isImgReady"
                :src="
                  isBeauty ? picItems.beauty_wm_url : picItems.no_beauty_wm_url
                "
                @load="imgLoad"
                ref="pic"
                ondragstart="return false;"
                class="upload-img"
                :width="uploadImgWidth"
                :height="uploadImgHeight"
                alt
              />
            </div>
          </div>
        </a-spin>
      </div>
      <div class="sidebar-col column-flex-between">
        <sideBar title="保存" iconType="download">
          <div class="sidebar-con save-con">
            <a-button @click="showPayPopFn" class="btn" type="primary" block
              >保存</a-button
            >
            <router-link :to="{ path: '/maker' }">
              <a-button class="btn" block>重新上传</a-button>
            </router-link>
          </div>
        </sideBar>
        <sideBar title="背景色" iconType="copy">
          <div class="sidebar-con background-con">
            <div class="scroll-wrp">
              <selColor
                :colors="colors"
                :colorsIdx="colorsIdx"
                :changeIdx="changeIdx"
              ></selColor>
            </div>
          </div>
        </sideBar>
        <sideBar title="换正装" iconType="user">
          <div class="clothes-con">
            <a-spin :spinning="changeClsSpin" tips="换装中...">
              <a-tabs :tabBarGutter="1" @change="callback" type="card">
                <a-tab-pane class="scroll-wrp woman" tab="女士" key="1">
                  <div class="clothes-items">
                    <div
                      @click="changeCls(false)"
                      :class="`item ${!clsOptSelNum && `active`}`"
                    >
                      <img src="../assets/noCls.png" alt />
                      <div class="text">无正装</div>
                    </div>
                    <div
                      :class="`item ${
                        clsOptSelNum && clsOptSelNum['girl'] == idx && 'active'
                      }`"
                      @click="changeCls('girl', idx)"
                      v-for="(item, idx) in clothesOpt['girl']"
                      :key="idx"
                    >
                      <a-spin :spinning="item.spin">
                        <img :src="item.value" @load="item.imgOnload()" alt />
                      </a-spin>
                      <div class="text">{{ "w" + (idx + 1) }}</div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane class="scroll-wrp kid" tab="儿童" key="2">
                  <div class="clothes-items">
                    <div
                      @click="changeCls(false)"
                      :class="`item ${!clsOptSelNum && `active`}`"
                    >
                      <img src="../assets/noCls.png" alt />
                      <div class="text">无正装</div>
                    </div>
                    <div
                      :class="`item ${
                        clsOptSelNum && clsOptSelNum['kid'] == idx && 'active'
                      }`"
                      style
                      @click="changeCls('kid', idx)"
                      v-for="(item, idx) in clothesOpt['kid']"
                      :key="idx"
                    >
                      <a-spin :spinning="item.spin">
                        <img :src="item.value" @load="item.imgOnload()" alt />
                      </a-spin>
                      <div class="text">{{ "K" + (idx + 1) }}</div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane class="scroll-wrp man" tab="男士" key="3">
                  <div class="clothes-items">
                    <div
                      @click="changeCls(false)"
                      :class="`item ${!clsOptSelNum && `active`}`"
                    >
                      <img src="../assets/noCls.png" alt />
                      <div class="text">无正装</div>
                    </div>
                    <div
                      :class="`item ${
                        clsOptSelNum && clsOptSelNum['boy'] == idx && 'active'
                      }`"
                      @click="changeCls('boy', idx)"
                      v-for="(item, idx) in clothesOpt['boy']"
                      :key="idx"
                    >
                      <a-spin :spinning="item.spin">
                        <img :src="item.value" @load="item.imgOnload()" alt />
                      </a-spin>
                      <div class="text">{{ "M" + (idx + 1) }}</div>
                    </div>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </a-spin>
          </div>
        </sideBar>
        <div class="flex-center beauty-wrap" style>
          <span>人像美颜</span>
          <a-switch defaultChecked @change="onChange" />
        </div>
      </div>
    </div>
    <payPop
      ref="payPop"
      picType="single"
      :colors="colors"
      :colorsIdx="colorsIdx"
      :isClothesBol="isClothes"
      :isMakePic="true"
      v-if="showPayPop"
      :cancel="cancel"
      :isVisible="showPayPop"
      :specId="ruleItemInfo.spec_id"
      :setImageKeyToSessionStorage="setImageKeyToSessionStorage"
    ></payPop>
  </div>
</template>

<script>
import sideBar from "@/components/sidebar.vue";
import selColor from "@/components/selColor.vue";
// import payPop from "@/components/payPop.vue";
import payPop from "@/components/pay.vue";
import { getClothes, changeClothes } from "@/utils/api";

import { setCookie } from "../utils/cookie";
export default {
  data() {
    return {
      isImgReady: false,
      scaleVal: 0,
      rotateVal: 0,
      rule: {
        width: 412,
        height: 573,
      },
      colors: [],
      ruleItemInfo: JSON.parse(sessionStorage.getItem("ruleItemInfo")),
      actualRuleInfo: {},
      isBeauty: true,
      protalPicInfo: {
        beauty_wm_url: JSON.parse(sessionStorage.getItem("makePicInfo")).wm_url,
        no_beauty_wm_url: JSON.parse(sessionStorage.getItem("makePicInfo"))
          .no_wm_url,
        beauty_key: JSON.parse(sessionStorage.getItem("makePicInfo")).key,
        no_beauty_key: JSON.parse(sessionStorage.getItem("makePicInfo")).no_key,
        origin_key: JSON.parse(sessionStorage.getItem("makePicInfo"))
          .origin_key,
        no_origin_key: JSON.parse(sessionStorage.getItem("makePicInfo"))
          .no_origin_key,
      },
      picItems: {
        beauty_wm_url: JSON.parse(sessionStorage.getItem("makePicInfo")).wm_url,
        no_beauty_wm_url: JSON.parse(sessionStorage.getItem("makePicInfo"))
          .no_wm_url,
        beauty_key: JSON.parse(sessionStorage.getItem("makePicInfo")).key,
        no_beauty_key: JSON.parse(sessionStorage.getItem("makePicInfo")).no_key,
      },
      clothesOpt: {},
      clsOptSelNum: false,
      showPayPop: false,
      colorsIdx: 0,
      changeClsSpin: false,
      isClothes: false,
      uploadImgWidth: "",
      uploadImgHeight: "",
    };
  },
  metaInfo() {
    return {
      title: "证件照片在线制作（专业版）",
      meta: [],
    };
  },
  // computed: mapState({ colors: state => state.colors }),
  components: { selColor, sideBar, payPop },
  beforeCreate() {
    if (
      !JSON.parse(sessionStorage.getItem("makePicInfo")) ||
      !JSON.parse(sessionStorage.getItem("ruleItemInfo"))
    ) {
      this.$router.replace(
        `/${sessionStorage.getItem("enterRecord") || "maker"}`
      );
    }
  },
  mounted() {
    let token = this.$route.query.token;
    let type = this.$route.query.type;
    if (type) {
      setCookie("lq-login-type", type, 1);
    }
    if (token) {
      setCookie("lq-handlephoto-token", token, 1);
    }
    this.initRuleColors();
    this.initClothes();
    this.handleRuleInfo(this.ruleItemInfo);
    if (type === "wechat") {
      this.getSession();
      // this.$refs.payPop.goPay();
      if (sessionStorage.getItem("payState")) {
        this.showPayPop = true;
      }
    }
  },
  methods: {
    getSession() {
      const states = ["colorsIdx", "clsOptSelNum", "picItems", "isClothes"];
      for (let i = 0; i < states.length; i++) {
        const element = states[i];
        const state = JSON.parse(sessionStorage.getItem(element));
        if (state !== null && state !== "") {
          this[element] = state;
        }
      }
    },
    setSession() {
      const states = ["colorsIdx", "clsOptSelNum", "picItems", "isClothes"];
      for (let i = 0; i < states.length; i++) {
        const element = states[i];
        sessionStorage.setItem(element, JSON.stringify(this[element]));
      }
    },
    handleRuleInfo({ width_px, height_px }) {
      if (width_px > 944 || height_px > 808) {
        this.actualRuleInfo = Object.assign({}, this.ruleItemInfo);
        this.ruleItemInfo.width_px = parseInt(this.ruleItemInfo.width_px / 3);
        this.ruleItemInfo.height_px = parseInt(this.ruleItemInfo.height_px / 3);
      }
    },
    async initClothes() {
      const getClothesDt = (await getClothes()).result;
      for (const key in getClothesDt) {
        if (getClothesDt.hasOwnProperty(key)) {
          const element = getClothesDt[key];
          element.map((item) => {
            item.spin = true;
            item.imgOnload = function () {
              item.spin = false;
            };
            return item;
          });
        }
      }
      this.clothesOpt = getClothesDt;
    },
    initRuleColors() {
      this.colors = JSON.parse(
        sessionStorage.getItem("ruleItemInfo")
      ).background_color.map((item) => {
        return {
          ...item,
          s_color: item.start_color.toString(16).padStart(6, 0),
          e_color: item.enc_color.toString(16).padStart(6, 0),
        };
      });
    },
    imgLoad(e) {
      let { width: w, height: h } = this.$refs.pic;
      let { width: rw, height: rh } = this.rule;
      this.handleRuleInfo(this.ruleItemInfo);
      if (w / rw >= h / rh) {
        this.uploadImgWidth = +this.ruleItemInfo.width_px;
      } else if (h / rh > w / rw) {
        this.uploadImgHeight = +this.ruleItemInfo.height_px;
      }
      this.isImgReady = true;
      // this.changeClsSpin = false;
    },
    changeCls(opt, idx) {
      if (opt === false) {
        this.picItems = this.protalPicInfo;
        this.clsOptSelNum = false;
        this.isClothes = false;
        return;
      }
      let key = this.clothesOpt[opt][idx].key;
      this.changeClsSpin = true;
      let data = {
        clothes_key: [key],
        origin_key: this.protalPicInfo.origin_key,
        spec_id: this.ruleItemInfo.spec_id,
      };
      changeClothes(data)
        .then((res) => {
          if (res.code == 200) {
            this.clsOptSelNum = {};
            this.clsOptSelNum[opt] = idx;
            this.isClothes = true;
            this.picItems = res.result;
            this.changeClsSpin = false;
          }
          // this.beauty_wm_url = res.result.beauty_wm_url;
          // this.no_beauty_wm_url = res.result.no_beauty_wm_url;
        })
        .catch((res) => {
          this.changeClsSpin = false;
        });
    },
    showPayPopFn() {
      // this.isBeauty
      //   ? sessionStorage.setItem("image_key", this.picItems.beauty_key)
      //   : sessionStorage.setItem("image_key", this.picItems.no_beauty_key);
      // sessionStorage.setItem(
      //   "image_key",
      //   this.picItems[this.isBeauty ? "beauty_key" : "no_beauty_key"]
      // );
      this.setImageKeyToSessionStorage(this.isClothes);
      this.showPayPop = true;
    },
    setImageKeyToSessionStorage(bol) {
      sessionStorage.setItem(
        "image_key",
        this[bol ? "picItems" : "protalPicInfo"][
          this.isBeauty ? "beauty_key" : "no_beauty_key"
        ]
      );
    },
    changeIdx(idx) {
      this.colorsIdx = idx;
    },
    reset() {
      this.rotateVal = 0;
      this.scaleVal = 0;
    },
    onChange(checked) {
      this.isBeauty = checked;
    },
    callback(key) {},
    cancel() {
      this.showPayPop = false;
    },
  },
};
</script>
<style scoped>
.scroll-wrp {
  height: 100%;
}
.save-con {
  padding: 11px 15px;
}
.clothes-con {
  height: 390px;
  background: #ffffff;
  overflow: hidden;
}
.background-con {
  height: 86px;
  overflow: hidden;
}
.background-con .scroll-wrp {
  padding: 11px 27px 11px 15px;
}
.column-flex-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.btn {
  height: 40px;
  margin-bottom: 8px;
}

.clothes-items {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 12px 0 12px 16px;
}
.clothes-items .item {
  width: 60px;
  border-radius: 6px;
  overflow: hidden;
  margin: 7px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  border: 1px solid #cccccc;
  height: min-content;
}
.clothes-items .item:last-child:nth-child(3n + 2) {
  margin-right: calc(((100% - 60px * 3) / 2 + 60px) * 1);
}
.clothes-items .item.active {
}
.man .clothes-items .item.active .text {
  background: #5965bc;
  color: #ffffff;
}
.woman .clothes-items .item.active .text {
  background: #ea7a6a;
  color: #ffffff;
}
.kid .clothes-items .item.active .text {
  background: #8dc5cd;
  color: #ffffff;
}
.clothes-items .item img {
  width: 100%;
  /* height: 48px; */
}
.tab-bar {
  width: 33%;
}
.text {
  width: 100%;
  height: 20px;
  line-height: 20px;
  /* background: #5965bc;
  color: #ffffff; */
  font-size: 12px;
  display: block;
}
.toolBtn-wrp {
  justify-content: space-between;
  margin-top: 25px;
}
.toolBtn-wrp button {
  width: 99px;
  height: 30px;
}
.img-wrap {
  display: inline-block;
}
.upload-img {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}
.beauty-wrap {
  border: 1px solid #e4e6ea;
  height: 48px;
  background: #ffffff;
  justify-content: space-between;
  font-size: 14px;
  padding: 0 16px;
}
.wpx,
.hpx,
.wmm,
.hmm {
  font-size: 12px;
  position: absolute;
  padding: 0 5px;
}
.sure-wrap .wpx,
.sure-wrap .hpx,
.sure-wrap .wmm,
.sure-wrap .hmm {
  background: #ebedf0;
}
.wpx,
.wmm {
  left: 50%;
  transform: translateX(-50%);
}
.hpx,
.hmm {
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
}
.wpx {
  top: -20px;
}
.wmm {
  bottom: -24px;
}
.hpx {
  left: -14px;
  transform: translateX(-50%) rotate(-90deg);
}
.hmm {
  right: -16px;
  transform: translateX(50%) rotate(-90deg);
}
</style>
